// extracted by mini-css-extract-plugin
export default {"slide_container":"TaskResultSlide_slide_container__2ceo6","task":"TaskResultSlide_task__VlNvZ"};